import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
/**
 * ### Combines class names using clsx and merges Tailwind utility classes with twMerge.
 *
 * This function takes an array of class values, which can include strings,
 * arrays, or objects, and first combines them using clsx to handle conditional
 * class names. The result is then processed by twMerge to intelligently merge
 * Tailwind utility classes, ensuring that classes like responsive, hover, and
 * focus variants are correctly merged and deduplicated.
 *
 * @param {...ClassValue[]} inputs - The class values to combine and merge.
 * ClassValue can be a string, array, or object representing class names,
 * including conditional classes.
 * @returns {string} - The combined and merged class name string.
 *
 * @example
 * // Returns 'text-blue-500 hover:text-blue-700'
 * cn('text-blue-500', {'hover:text-blue-700': true})
 *
 * @example
 * // Returns 'p-4 md:p-8'
 * cn('p-4', 'md:p-8')
 */
export var cn = function () {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    return twMerge(clsx(inputs));
};
